<form-layout
    [showSave]="canSave"
    [showVorabCheck]="true"
    (onSave)="onSaveClick()"
    (onBack)="onBackClick()"
    (onNext)="onSaveAndNextClick()">
    
    <project-data [form]="projectDataProcessStepForm"></project-data>
</form-layout>
